import { SET_STORY_MODE, FETCH_CONTENT_SUCCESS, FETCH_CLAIMS_SUCCESS } from "../actions";
export default function(store) {
    return function(next) {
        return function(action) {
            if (window.__ExtensionAPI) {
                var state;
                var student;
                var claims;
                switch(action.type){
                    case SET_STORY_MODE:
                        state = store.getState();
                        student = state.api ? state.api.getStudent() : {};
                        window.__ExtensionAPI.triggerEvent("cbook", {
                            name: state.cbook && state.cbook.name || "",
                            storyMode: state.storyMode,
                            language: state.cbook && (state.cbook.default_ui_language || state.cbook.default_frontend_language) || "en",
                            theme: state.cbook && state.cbook.theme || "light",
                            useIconFontFallback: state.cbook && state.cbook.use_icon_font_images,
                            isPreviewMode: false,
                            student_id: student.id,
                            student_name: student.name
                        });
                        break;
                    case FETCH_CONTENT_SUCCESS:
                        var _action_content;
                        if ((_action_content = action.content) === null || _action_content === void 0 ? void 0 : _action_content.extension_id) {
                            var _action_content1, _state_api;
                            state = store.getState();
                            var _cont;
                            if (typeof ((_action_content1 = action.content) === null || _action_content1 === void 0 ? void 0 : _action_content1.cont) === "string") {
                                _cont = JSON.parse(action.content.cont.length ? action.content.cont : "{}");
                            } else {
                                _cont = action.content.cont;
                            }
                            _cont.status = ((_state_api = state.api) === null || _state_api === void 0 ? void 0 : _state_api.getSlideStatus(action.id)) || "not attempted";
                            window.__ExtensionAPI.triggerEvent("chart", _cont, {
                                chartId: action.id
                            });
                        }
                        break;
                    case FETCH_CLAIMS_SUCCESS:
                        state = store.getState();
                        claims = state.currentSlide ? action.claims[state.currentSlide] : null;
                        if (claims) {
                            window.__ExtensionAPI.triggerEvent("claims", claims.map(function(c) {
                                return {
                                    local_id: c.local_id,
                                    claim_type: c.claim_type
                                };
                            }), {
                                chartId: state.currentSlide
                            });
                        }
                        break;
                    default:
                        break;
                }
            }
            return next(action);
        };
    };
};
